import "../styles/home/Home.css";

const HeroSpeaker = () => {
  return (
    <div>
      <section className="hero">
        
        <div className="container">
          <div className="row">
            <div className="col-md">
              <h1 className="full ">Meet Our 2023  Speakers </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
            <span className="textSize-speaker" > Kelly Burton, CEO, Black Annovation Alliance </span>

            </div>
       
          </div>
        </div>
        <span class="hero-bottom-text"></span>
      </section>
    </div>
  );
};
export default HeroSpeaker;
